import React from "react";

/**

GlyphCard.js

Displays metadata for a focused glyph.

Reads from the current memory focus state. */


export default function GlyphCard({ glyph }) { if (!glyph) return null;

return ( <div style={{ backgroundColor: "#111", border: "1px solid #00ffff", borderRadius: "10px", padding: "20px", maxWidth: "500px", margin: "0 auto", }} > <h2 style={{ fontSize: "1.25rem", color: "#00ffff", marginBottom: "10px" }}> {glyph.id} – {glyph.name} </h2> <p style={{ color: "#ccc", fontSize: "0.9rem" }}><strong>Origin:</strong> {glyph.origin}</p> <p style={{ color: "#eee", fontSize: "1rem", marginTop: "8px" }}><strong>Meaning:</strong> {glyph.meaning}</p> </div> ); }

